export default {
  currentCall(state) {
    
  },
  loading: (state) => state.loading,
};



// WEBPACK FOOTER //
// ./src/store/dialer_v2/getters.js